module.exports = __webpack_public_path__ + "img/secure-green.bd0577a9.svg";